import script from "./WorkstationSwitchMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkstationSwitchMenu.vue?vue&type=script&setup=true&lang=js"

import "./WorkstationSwitchMenu.vue?vue&type=style&index=0&id=4951f392&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4951f392"]])

export default __exports__